"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["src"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
    key: 0,
    class: "w-4 h-4",
    version: "1.1",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("rect", {
    x: "2",
    y: "2",
    width: "12",
    height: "12",
    d: "m 3.5,2 h 9 A 1.5,1.5 45 0 1 14,3.5 v 9 A 1.5,1.5 135 0 1 12.5,14 h -9 A 1.5,1.5 45 0 1 2,12.5 v -9 A 1.5,1.5 135 0 1 3.5,2 Z",
    fill: "currentColor",
    "fill-rule": "evenodd",
    "stroke-linejoin": "round",
    "stroke-width": "3.7795"
}, null, -1);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = {
    key: 1,
    class: "w-4 h-4",
    version: "1.1",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("path", {
    transform: "matrix(1.5 0 0 1.5 -5.6003 -3.9998)",
    d: "m12.701 8.75-6.4019 3.6962a0.86603 0.86603 30 0 1-1.299-0.75v-7.3923a0.86603 0.86603 150 0 1 1.299-0.75l6.4019 3.6962a0.86603 0.86603 90 0 1 0 1.5z",
    fill: "currentColor",
    "fill-rule": "evenodd",
    "stroke-linejoin": "round",
    "stroke-width": "3.7795"
}, null, -1);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "relative bg-beige-100 h-[10px] flex-auto" };
// declare additional options
const __default__ = {
    inheritAttrs: false,
    customOptions: {},
};
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)(Object.assign(Object.assign({}, __default__), { __name: 'AudioPlayer', props: ['src'], setup(__props) {
        const props = __props;
        const playing = (0, vue_3.ref)(false);
        const audioEl = (0, vue_3.ref)();
        const progress = (0, vue_3.ref)(0);
        const progressUpdateTime = 16;
        let interval = null;
        const togglePlay = function () {
            if (!audioEl.value) {
                return;
            }
            if (audioEl.value.paused) {
                if (audioEl.value.paused) {
                    audioEl.value.play();
                }
            }
            else {
                if (!audioEl.value.paused) {
                    audioEl.value.pause();
                    audioEl.value.currentTime = 0;
                }
            }
        };
        function onPlaying() {
            interval = window.setInterval(updateProgress, progressUpdateTime);
            playing.value = true;
        }
        function onPause() {
            if (interval) {
                window.clearInterval(interval);
            }
            updateProgress();
            playing.value = false;
        }
        function updateProgress() {
            var _a, _b;
            let current = (_a = audioEl.value) === null || _a === void 0 ? void 0 : _a.currentTime;
            let duration = (_b = audioEl.value) === null || _b === void 0 ? void 0 : _b.duration;
            if (!current || !duration) {
                progress.value = 0;
                return;
            }
            let percent = (current / duration) * 100;
            progress.value = percent;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("audio", {
                    ref_key: "audioEl",
                    ref: audioEl,
                    src: props.src,
                    preload: "auto",
                    onPlaying: onPlaying,
                    onPause: onPause
                }, null, 40, _hoisted_1),
                (0, vue_2.createElementVNode)("div", (0, vue_2.mergeProps)({ class: "relative bg-beige-400 rounded-full px-5 py-3 flex items-center" }, _ctx.$attrs), [
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        onClick: (0, vue_2.withModifiers)(togglePlay, ["prevent"]),
                        class: "shrink-0 w-11"
                    }, [
                        (playing.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_3, _hoisted_5))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_6, _hoisted_8))
                    ], 8, _hoisted_2),
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        (0, vue_2.createElementVNode)("div", {
                            style: (0, vue_2.normalizeStyle)({ width: progress.value + '%' }),
                            class: "bg-yellow-500 absolute left-0 top-0 h-full"
                        }, null, 4),
                        (0, vue_2.createElementVNode)("div", {
                            style: (0, vue_2.normalizeStyle)({ left: progress.value + '%' }),
                            class: "absolute -translate-y-1/2 -translate-x-1/2 w-5 h-5 rounded-full top-1/2 bg-mutedpurple-800"
                        }, null, 4)
                    ])
                ], 16)
            ], 64));
        };
    } }));
